import _ from 'lodash';

import React from "react";
import { withApollo } from "react-apollo";

import ReactTable from 'react-table';
import treeTableHOC from 'react-table/lib/hoc/treeTable';
import Select from 'react-select';
import SweetAlert from "react-bootstrap-sweetalert";
import withStyles from "material-ui/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import GridContainer from "components/Grid/GridContainer";
import Button from "components/CustomButtons/Button.jsx";
import ItemGrid from "components/Grid/ItemGrid";
import IconCard from "components/Cards/IconCard";
import CustomInput from "components/CustomInput/CustomInput";
import IconButton from "components/CustomButtons/IconButton";
import DashboardIcon from "@material-ui/icons/Dashboard";
import PinDrop from "@material-ui/icons/PinDrop";
import Person from "@material-ui/icons/Person";

import { getPinLogsQuery, gq_pinLogs } from "../graph";
import {pinInnerColumns, pinBaseColumns,
        speakerInnerColumns, speakerBaseColumns} from "../constant";
import { downloadFile } from "lib/utils" ;
        

class PinLog extends React.Component{
    constructor(props){
      super(props);

      this.rev = '';
      this.revVal = '';
      this.pid = null;
      this.searchPlaceholder = "Search by pin id";
      this.fetchData = this.fetchData.bind(this)
      this.onViewButtonsChange = this.onViewButtonsChange.bind(this)
      this.state = {
        pins: [],
        pages: null,
        pageSize: 1,
        page: 1,
        loading: false,
        viewType: "pins",
        searchValue: "",
        sort: [],
        pageTitle: null,
        exportModalIsOpen: false,
      };
    }

    componentDidMount() {
      this.pid=this.props.match.params.id;
      this.fetchData();

    }

    getData(page, pageSize, viewType, order, orderBy, search) {

    }

    componentWillUnmount() {
    }

    fetchData(state=null, instance=null, options={}) {
      this.setState({ loading: true })
      let pid = null;

      if (this.props.match.params.id)
        pid = this.props.match.params.id;

      if (state){
          var filterBy = JSON.stringify(state.filtered)
          var offset = state.page
          var pageSize = state.pageSize
          var sort = JSON.stringify(state.sorted)
          this.setState({
            sort: state.sorted
          })
      } else {
          var filterBy = JSON.stringify([])
          var offset = 0
          var pageSize = 10
          var sort = JSON.stringify([])
          this.setState({
            sort: []
          })
      }
      // if (offset == (this.state.pages-1)){
      //    options = {fetchPolicy: 'no-cache'}
      // }
      this.props.client.query({
        query: gq_pinLogs,
        variables: {
          filterBy: filterBy,
          offset: offset, 
          pageSize: pageSize,
          sort: sort, 
          view: this.state.viewType,
          pid: pid
        },
        fetchPolicy: "network-only",
      }).then((results) => {
        this.setState({
          pins: results.data.pinLogs.pinlogs, 
          loading: false, 
          pages: results.data.pinLogs.pages
        });
      });
    }

    onViewButtonsChange(event) {
      this.setState({ 
        'viewType': event.value
      })

    }

    onSearchChange(event) {
      const value = event.target.value;

      this.setState({searchValue: value});
      this.getData((this.state.page + 1), this.state.pageSize, this.state.viewType, this.rev, this.revVal, value);
    }
    
    process_rows(pins){
      if (this.state.viewType == 'pins'){
        let grouped = _.groupBy(pins, 'pin');
        return Object.keys(grouped).map((key) => {
          let endtime = new Date(grouped[key][0].pin1.conversational.edges[0].node.scheduledConference.endtime)
          let now = new Date()
          let owner = (grouped[key][0].pin1.user) ? grouped[key][0].pin1.user.username : "";
          return {
            'pin': key, 
            'log': grouped[key], 
            'owner': owner, 
            'status': (now<endtime) ? 'Active' : 'Expired', 
            'maxRecordingLength': grouped[key][0].pin1.conversational.edges[0].node.maxRecordingLength, 
            'currentRecordingLength': grouped[key][0].pin1.conversational.edges[0].node.currentRecordingLength 
          }
        })
      } else {
        let grouped_by_speakeridInline = _.groupBy(pins, 'speakeridInline');
        let grouped_by_speakeridOutline = _.groupBy(pins, 'speakeridOutline');
        
        let merged_data = _.mergeWith(
          grouped_by_speakeridInline, 
          grouped_by_speakeridOutline, 
          (objValue, srcValue) => {
            if (_.isArray(objValue)){
              return objValue.concat(srcValue)
            }
          })
        return Object.keys(merged_data).map((key) => {
          let spkrId = null;
          let phone = null;
          let owner = (merged_data[key][0].pin1.user) ? merged_data[key][0].pin1.user.username : "";
          if (merged_data[key][0].speakerInline.spkrPk === key) {
              spkrId = merged_data[key][0].speakerInline.speakerId;
              phone = merged_data[key][0].speakerInline.phonenumber;
          }
          else {
              spkrId = merged_data[key][0].speakerOutline.speakerId;
              phone = merged_data[key][0].speakerOutline.phonenumber
          }
          
          return {
            'speakerid': spkrId, 
            'phone': phone, 
            'log': merged_data[key], 
            'owner': owner 
          }
        })
      }
    }

    onExportClick() {
        this.setState({exportModalIsOpen: true});
    }

    onDownloadButtonCancel() {
        this.setState({exportModalIsOpen: false});
    }

    onDownloadButtonConfirm() {
      let url = `${process.env.REACT_APP_SERVER_URL}api/logs/export/${this.pid}`;
             
      downloadFile(url, "tp-logs.csv");
      this.setState({exportModalIsOpen: false});
    }

    render() {
      const { pins, pages, loading, viewType, searchValue, exportModalIsOpen } = this.state;
       
      let showExportModal = null;
      const _usertype = localStorage.getItem("APN_USERTYPE");      

      let exportButton = ( _usertype == process.env.REACT_APP_ADMIN_ROLE || 
               _usertype == process.env.REACT_APP_PM_ROLE) ? 
                    <Button color="rose" 
                        type="submit" 
                        style={{"marginTop": "0"}}
                        onClick={this.onExportClick.bind(this)}>Export Logs</Button>
                        : null;

      const baseColumns = viewType === "pins" ? pinBaseColumns : speakerBaseColumns;
      const innerColumns = viewType === "pins" ? pinInnerColumns : speakerInnerColumns;
      const pinView = (<ReactTable
              data={this.process_rows(pins)}
              manual
              filterable
              pages={pages}
              onFetchData={this.fetchData}
              loading={loading}
              columns={baseColumns}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
              defaultPageSize={10}
              SubComponent={(row)=> {
                  let rowData = [];
                  if (viewType === "pins") {
                    rowData = _.forEach(row.original.log, (data) => {
                      return {
                        speakerInline: data.speakerInline.speakerId,
                        speakerOutline: data.speakerOutline.speakerId,
                        part: data.part,
                        callStart: data.callStart, 
                        callDuration: data.callDuration, 
                        demographicInline: data.demographicInline,
                        demographicOutline: data.demographicOutline,
                        phonenumberInline: data.phonenumberInline,
                        phonenumberOutline: data.phonenumberOutline
                      }
                    })
                  }
                  else {
                    rowData = _.forEach(row.original.log, (data) =>{
                      return {
                        pin: data.pin, 
                        part: data.part, 
                        status: 'active',
                        currentRecordingLength: data.pin1.conversational.edges[0].node.currentRecordingLength,
                        maxRecordingLength: data.pin1.conversational.edges[0].node.maxRecordingLength,
                        callDuration: data.callDuration,
                        demographicInline: data.demographicInline,
                        demographicOutline: data.demographicOutline,
                        phonenumberInline: data.phonenumberInline,
                        phonenumberOutline: data.phonenumberOutline
                      }
                    });
                  }

                  return (
                    <div style={{padding:'10px'}}>
                      <ReactTable 
                        data={rowData}
                        columns={innerColumns}
                        pageSize={rowData.length}
                        showPagination={false}
                      />
                    </div>
                  );
                }
              }
            />);

      if (exportModalIsOpen)
            showExportModal = (
                <SweetAlert
                  onConfirm={this.onDownloadButtonConfirm.bind(this)}
                  onCancel={this.onDownloadButtonCancel.bind(this)} 
                  confirmBtnCssClass={
                    this.props.classes.button + " " + this.props.classes.success
                  }
                  cancelBtnCssClass={
                    this.props.classes.button + " " + this.props.classes.danger
                  }
                  confirmBtnText="Export"
                  cancelBtnText="Cancel"
                  showCancel
                  title="Export logs?"
                  style={{overflow: "visible !important"}}
                 />
            );

      let viewOptions = [{
          label: "View By Pins",
          value: 'pins'
        }, {
          label: "View By Speaker ID",
          value: 'speakers'
        }];
        
      return (
        <GridContainer>
          {showExportModal}
          <ItemGrid xs={12}>
          <style>
              {`
                  .users-paddingleft {
                      padding-left: 0 !important;
                  }
                  .users-selecttop {
                      margin-top: 9px;
                  }
              `}
            </style>
            <IconCard
              icon={DashboardIcon}
              title="Pin Logs"
              content={
                  <ItemGrid xs={12}>
                    <ItemGrid xs={12} md={4} className="users-paddingleft">
                      <h4>{(!this.props.Project.loading && this.props.Project.project) ? this.props.Project.project.name : null}</h4>
                    </ItemGrid>
                    <ItemGrid xs={12} md={12} className="users-paddingleft">
                      <GridContainer>
                        <ItemGrid md={4}>
                          <Select options={viewOptions} 
                                value={this.state.viewType} 
                                onChange={this.onViewButtonsChange.bind(this)} 
                                clearable={false}
                                style={{marginTop: "3px"}} />
                        </ItemGrid>
                        <ItemGrid md={8}>
                                {exportButton}
                        </ItemGrid>
                      </GridContainer>
                    </ItemGrid>
                    <ItemGrid xs={12} style={{marginTop: "15px"}}>
                        {pinView}
                    </ItemGrid>
                  </ItemGrid>
              }
            />
          </ItemGrid>
        </GridContainer>
      )
    }
}

export default withStyles(sweetAlertStyle)((getPinLogsQuery)(withApollo(PinLog)));



// WEBPACK FOOTER //
// ./src/views/pin/components/PinLog.js